export default __webpack_public_path__ + "static/media/ML.03307d99.png";